// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10lpm","importantInfo":"styles_importantInfo__1EVKC"};